import React, { useEffect, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { getDataQuicksBookLogAsync } from '../../accountQBOnline/accountQBLog/QuicksBookLogSlice';
import moment from 'moment';
import '../../../../common/css/timeLive.css'
import './QuickBooksLog.css'

const QuickBookLogItem = (props: any) => {
    const { quikBookLogList, t, IsEdit } = props;
    const dispatch = useAppDispatch();
    const { isReload, selectedRecord, isLoading } = useAppSelector((state) => state.quicksBookLog);

    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle">
                        <th className='w-20'>{t('Executed Date')}</th>
                        <th className='w-20'>{t('Data Display Name')}</th>
                        <th className='w-15'>{t('Message')}</th>
                        <th className='w-15'>{t('Message Detail')}</th>
                        <th className='w-15'>{t('Status')}</th>
                        <th className='w-15'>{t('Event Type')}</th>
                    </tr>
                </thead>
                <tbody>
                    {quikBookLogList.length > 0 && quikBookLogList.map((quikBookData: any, i: any) => (
                        <tr key={i} style={{ height: 42 }}>
                            <td>
                                {moment(quikBookData.ExecutedDate).format('M-D-YYYY')}
                            </td>
                            <td>
                                {quikBookData.DataDisplayName}
                            </td>
                            <td>
                                {quikBookData.Message}
                            </td>
                            <td>
                                {quikBookData.MessageDetail}
                            </td>
                            <td>
                                {quikBookData.ActionStatus}
                            </td>
                            <td>
                                {quikBookData.SystemActionTypeName}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {quikBookLogList.length === 0 &&
                <div className=''>
                    <p className='noDataFound'>{t('No Record Found')}</p>
                </div>
            }
        </>
    )
}

export default QuickBookLogItem